<template>
<div style="width: 100%">
	<v-subheader>
		{{$t('workers.title')}} > {{$t('workers.worker')}} #{{ $route.params.workerId }}
	</v-subheader>
	<general-info />
	<v-tabs
		v-model="tab"
		show-arrows
	>
		<v-tabs-slider />

		<v-tab
			v-for="(n, i) in tabs"
			:to="'#' + n.value"
			:key="i+1"
		>
			{{n.name}}
		</v-tab>

		<v-tabs-items>
			<v-tab-item
				v-for="(item, i) in tabs"
				:id="item.value"
				:key="i"
			>
				<v-card flat>
					<component :is="item.component" />
				</v-card>
			</v-tab-item>
		</v-tabs-items>
	</v-tabs>
	<Loader v-if="isLoading" />
</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import GeneralInfo from './workers/GeneralInfo.vue'
import GeneralTab from './workers/tabs/general/GeneralTab'
import FinanceTab from './workers/tabs/finance/FinanceTab'
import JobsTab from './workers/tabs/jobs/JobsTab'
import ScansTab from './workers/tabs/scans/ScansTab'
import CommentsTab from './workers/tabs/comments/CommentsTab'
import HistoryTab from './workers/tabs/HistoryTab'
import AccommodationTab from './workers/tabs/accommodation/AccommodationTab'
import Loader from '../components/Loader'

export default {
	components: {
		GeneralInfo,
		Loader
	},
	data: vm => ({
		tab: '',
		items: [
			{
				value: 'general',
				name: vm.$t('workers.tab.general'),
				roles: ['admin', 'manager'],
				component: GeneralTab
			},
			{
				value: 'accommodation',
				name: vm.$t('workers.tab.accommodation'),
				roles: ['admin', 'manager'],
				component: AccommodationTab
			},
			{
				value: 'jobs',
				name: vm.$t('workers.tab.jobs'),
				roles: ['admin', 'manager'],
				component: JobsTab
			},
			{
				value: 'scans',
				name: vm.$t('workers.tab.scans'),
				roles: ['admin', 'manager'],
				component: ScansTab
			},
			{
				value: 'finance',
				name: vm.$t('workers.tab.finance'),
				roles: ['admin', 'manager', 'canPrepay'],
				component: FinanceTab
			},
			{
				value: 'comments',
				name: vm.$t('workers.tab.comments'),
				roles: ['admin', 'manager'],
				component: CommentsTab
			},
			{
				value: 'history',
				name: vm.$t('workers.tab.history'),
				roles: ['admin', 'manager'],
				component: HistoryTab
			}
		],
		list: {
			general: () => {
				vm.$store.dispatch('workers/fetchOne')
			},
			jobs: () => {
				vm.$store.dispatch('workers/fetchOne')
			},
			scans: () => {
				vm.$store.dispatch('workers/fetchOne')
			},
			finance: () => {
				vm.$store.dispatch('workers/getFinance')
			},
			comments: () => {
				vm.$store.dispatch('workers/getComments')
			},
			history: () => {
				vm.$store.dispatch('workers/getHistory')
			},
			accommodation: () => {
				vm.$store.dispatch('workers/fetchOne')
			}
		}
	}),
	created() {
		if (this.permission) {
			this.$store.dispatch('workers/getHistory')
			this.$store.dispatch('workers/getComments')
			this.$store.dispatch('agencies/fetch', {
				count: 100
			})
			this.$store.dispatch('templates/fetch')
		}
		this.$store.dispatch('workers/fetchOne')
		this.$store.dispatch('workers/getFinance')
		this.$store.dispatch('workers/fetchPreview')
	},
	computed: {
		...mapState({
			isLoading: ({ workers }) => workers.isLoadingDetail
		}),
		...mapGetters({
			hasRole: 'auth/hasRole'
		}),
		permission() {
			return !this.hasRole('canPrepay')
		},
		tabs() {
			return this.items.filter(
				({ roles }) => !!roles.find(role => this.hasRole(role))
			)
		}
	},
	watch: {
		tab(next, prev) {
			if (next !== prev) {
				this.list[next]()
			}
		}
	}
}
</script>
